module.exports = __webpack_public_path__ + "img/南昌大学.2f72791a.png";